import { auth } from './api-auth'

const API = {
  auth
}


export { API }